import React, {useState, useEffect}  from 'react';
import {Container, Alert, Table, Button} from 'react-bootstrap';
import {useNavigate, useParams, Link} from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../util/Api';
//import {isAuthenticated} from '../../util/Auth';
import {useSelector} from 'react-redux';
import {getUserAccounts} from '../../app/slices/UserSlice';


const GuardrailList = () => {

  const [errors, setErrors] = useState([]);
  const [guardrails, setGuardrails] = useState([]);
  const [atLimit, setAtLimit] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [app, setApp] = useState(null);

  let navigate = useNavigate();

  let {accountKey, appKey} = useParams();

  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

  useEffect(() => {
    document.title = `reconify guardrails`;
    //is an account selected?
    let options = {
      accountKey: accountKey,
      appKey: appKey
    }
    let isAuthError = false;
    axios.post(apiUrl + '/guardrails/list',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        if(Array.isArray(res.data.alerts)){
          setGuardrails(res.data.alerts);
          if(res.data.alerts.length >= currUserAccount.alertLimit){
            setAtLimit(true)
          }
        }
        else {
          //show message on how to create a guardrail alert
          setShowWelcome(true)
        }
        if (res.data.app !== null) {
            setApp(res.data.app);
            document.title = `reconify guardrails ${res.data.app.app}`;
        }
      } else {
        if(guardrails?.length > 0) {
            setGuardrails([])
        }
        if (res.data.app !== null) {
            setApp(res.data.app);
            document.title = `reconify guardrails ${res.data.app.app}`;
        }
        let errorMsgs = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-auth':
            case 'no-valid-account':
            case 'no-permissions':
              //console.log('auth expired');
              isAuthError = true;
              //navigate('/login');
              //errorMsgs.push('You have been logged out.');
              //return;
              redirectToLogin = true;
              break;
            case 'no-results':
              setShowWelcome(true)
              break;
            default:
                console.log('some other error', error)
              errorMsgs.push('There was an error retrieving guardrails.');
          }
        });
        //don't call setErrors if not logged in as it throws an unmounted error
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
      }
    })
    .catch((err) => {

    });
  },[navigate, accountKey, appKey, currUserAccount]);

  const sortByTag = () => {
    //console.log('sorting name')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.tag < b.tag) ? -1 : 1)
    setGuardrails(temp);
  }

  const sortByType = () => {
    //console.log('sorting key')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.typeId < b.typeId) ? -1 : 1)
    setGuardrails(temp);
  }
  const sortByThreshold = () => {
    //console.log('sorting key')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.threshold < b.threshold) ? -1 : 1)
    setGuardrails(temp);
  }
  const sortByEmail = () => {
    //console.log('sorting key')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.email < b.email) ? -1 : 1)
    setGuardrails(temp);
  }
  const sortByWebhook= () => {
    //console.log('sorting key')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.webhook < b.webhook) ? -1 : 1)
    setGuardrails(temp);
  }
  const sortByActive= () => {
    //console.log('sorting key')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.isActive < b.isActive) ? -1 : 1)
    setGuardrails(temp);
  }
  const sortByDate = () => {
    //console.log('sorting date')
    let temp = [...guardrails]
    temp.sort((a,b) => (a.created < b.created) ? 1 : -1)
    setGuardrails(temp);
  }

  return (
    <Container fluid>
        <div>
          <h3>Guardrails: {app !== null ? (<span className='report-subject'>{app.app}</span>) : null}</h3>
          {
            showWelcome ? (
              
              <Alert>
                <div>Guardrails can be created by setting an alert on 
                    a <Link to={`/account/${accountKey}/analytics/app/${appKey}/prompts`}>prompt</Link> or 
                    a <Link to={`/account/${accountKey}/analytics/app/${appKey}/responses`}>response</Link> from 
                    the analytics reports.</div>
                <div>Similar prompts or responses will then trigger a notification to an email and/or webhook.</div>
                <div>Simply select a prompt or response from the analytics, and then the "add guardrail" button.</div>
                {currRoleId < 2 ? (<div>You need edit permissions to create a Guardrail.</div>) : null}
              </Alert>
              
            ) : (null)
          }
          
          {
            errors.length > 0 ? (
              <Alert variant='danger'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
              </Alert>
            ) : (null)
          }
          {
            guardrails.length > 0 ? (
              <div className='chart-card chart-card-table'>
              <Table  hover>
                <thead>
                  <tr>
                    <th><span onClick={sortByTag} role="button">Tag</span></th>
                    <th><span onClick={sortByType} role="button">Type</span></th>
                    <th><span onClick={sortByThreshold} role="button">Threshold</span></th>
                    <th><span onClick={sortByEmail} role="button">Email</span></th>
                    <th><span onClick={sortByWebhook} role="button">Webhook</span></th>
                    <th><span onClick={sortByActive} role="button">Status</span></th>
                    <th><span onClick={sortByDate} role="button">Created</span></th>
                    <th colSpan={2}>actions</th>
                  </tr>
                </thead>
                <tbody>
                {
                  guardrails.map((guardrail, i) => (
                    <tr key={'guardrail.' + i}>
                      <td>{guardrail.tag}</td>
                      <td>{guardrail.typeId == 1 ? 'prompt' : 'response'}</td>
                      <td>{guardrail.threshold}</td>
                      <td>{guardrail.email}</td>
                      <td>{guardrail.webhook}</td>
                      <td>{guardrail.isActive  == 1? 'Active' : 'Disabled'}</td>
                      <td>{new Date(guardrail.created).toLocaleDateString()} {/*new Date(guardrail.created).toLocaleTimeString()*/}</td>
                      <td><Link to={`/account/${accountKey}/guardrails/app/${appKey}/detail/${guardrail.alertId}`} className='btn btn-primary btn-sm'>details</Link></td>
                      <td><Link to={`/account/${accountKey}/analytics/app/${appKey}/guardrails?alertId=${guardrail.alertId}`} className='btn btn-secondary btn-sm'>activity</Link></td>
                    </tr>
                  ))
                }
                </tbody>
              </Table>
              </div>
            ) : (
              null
            )
          }
        </div>


    </Container>
  )
}

export default GuardrailList;
